import { JobOptionSvc } from 'domains/jobconfigDomain';
import { RevxRadio } from 'components';
import { RevxRadioProps } from 'components/RevxRadio';
import CommonJobSvcImg from './CommonJobSvcImg';
import { useEffect, useState } from 'react';

interface Props {
  list?: JobOptionSvc[];
  disabled?: boolean;
  value?: number;
  onChange?: (value: number) => void;
  isBundling?: boolean;
}

const CommonOneofFormRadio = (props: Props) => {
  const { value, onChange, list, disabled } = props;

  const [curValue, setCurValue] = useState(value);

  useEffect(() => {
    // controlled mode
    if (value !== undefined) {
      setCurValue(value);
    }
  }, [value, list]);

  const CommonOneofRadioRender = (): RevxRadioProps => {
    return {
      disabled,
      iconSequence: 'last',
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
        },
      },
      inSideRevxLayoutProps: {
        direction: 'column',
        align: 'center',
        justify: 'left',
        className: 'jobconfig-jobOption-content-inSideOption-default',
        style: {
          marginRight: 31,
        },
      },
      options:
        list?.map((svc) => {
          return {
            value: svc.id,
            children: (
              <>
                <CommonJobSvcImg {...svc} isOneOf />
                <span style={{ padding: '10px 0px' }}>{svc.name}</span>
              </>
            ),
          };
        }) || [],
    };
  };

  return (
    <>
      <RevxRadio
        {...CommonOneofRadioRender()}
        value={curValue}
        onChange={(val: string | number) => {
          // if (value === undefined) {
          //   // uncontroled mode
          setCurValue(+val);
          // }
          if (onChange) {
            onChange(+val);
          }
        }}
      />
    </>
  );
};

export default CommonOneofFormRadio;
